import { TinyEmitter } from 'tiny-emitter';

export const AppEvents = new TinyEmitter();

class Events {
  static readonly Foreman = class {
    static readonly Deleted: string = 'foreman:deleted';
  };
  static readonly Movement = class {
    static readonly Deleted: string = 'movement:deleted';
  };
}

export default Events;
